function initials(name) {
  return String(name || "N").split(/\s+/).map(part => part[0]).join("").slice(0, 2).toUpperCase();
}

export function applyUserContext(profile, role, mode) {
  const name = profile.full_name || profile.email || "NAYSOR User";
  document.getElementById("userDisplayName").textContent = name;
  document.getElementById("userRoleLabel").textContent = String(role || "viewer").replaceAll("_", " ");
  document.getElementById("popoverUserName").textContent = name;
  document.getElementById("popoverUserEmail").textContent = profile.email || "";
  const avatar = document.getElementById("userAvatar");
  avatar.textContent = initials(name);
  if (profile.avatar_url) {
    avatar.style.backgroundImage = 'url("' + profile.avatar_url.replaceAll('"', "%22") + '")';
    avatar.classList.add("has-image");
  } else {
    avatar.style.backgroundImage = "";
    avatar.classList.remove("has-image");
  }
  document.body.dataset.storageMode = mode;
}

export function setConnectionState(state, detail = "") {
  const badge = document.getElementById("networkBadge");
  const container = document.getElementById("connectionState");
  const saveState = document.getElementById("saveState");
  const english = document.documentElement.lang === "en";
  const labels = {
    online: ["ONLINE", "클라우드 연결됨", "Cloud connected"],
    demo: ["DEMO", "Demo 메모리 모드", "Demo memory mode"],
    offline: ["OFFLINE", "오프라인 · 저장 차단", "Offline · writes blocked"],
    saving: ["SAVING", "클라우드 저장 중", "Saving to cloud"],
    saved: ["SAVED", "클라우드 저장 완료", "Cloud save complete"],
    failed: ["ERROR", "저장 실패", "Save failed"],
    conflict: ["CONFLICT", "동시 수정 충돌", "Concurrent edit conflict"],
    connecting: ["CONNECTING", "연결 확인 중", "Checking connection"]
  };
  const [short, korean, englishLabel] = labels[state] || labels.connecting;
  badge.className = "connection-pill " + state;
  badge.textContent = short;
  container.dataset.state = state;
  saveState.textContent = detail || (english ? englishLabel : korean);
}

export function renderPresence(users = []) {
  const uniqueUsers = [...new Map(users.filter(Boolean).map(user => [user.id || user.email, user])).values()];
  window.NAYSOR_PRESENCE = uniqueUsers;
  const root = document.getElementById("presenceUsers");
  const count = document.getElementById("presenceCount");
  if (count) count.textContent = String(uniqueUsers.length);
  root.innerHTML = uniqueUsers.slice(0, 5).map(user => {
    const name = user.full_name || user.email || "User";
    const image = user.avatar_url
      ? "style=\"background-image:url('" + String(user.avatar_url).replaceAll("'", "%27") + "')\""
      : "";
    return '<span class="presence-avatar" ' + image + ' title="' + name.replaceAll('"', "&quot;") + '">' + (image ? "" : initials(name)) + "</span>";
  }).join("") + (uniqueUsers.length > 5 ? '<span class="presence-more">+' + (uniqueUsers.length - 5) + "</span>" : "");
  window.dispatchEvent(new CustomEvent("naysor:presence", { detail: uniqueUsers }));
}
